<app-generic-side-modal-container [sideNavTitleText]="'Membership types' | translate">
  <div mainPageContent class="w-full padding_20 ">
    <div class="flex flex-col sm:flex-row gap-5 justify-between">
      <h1 class="uppercase text-[#475569] font-bold text-3xl lg:text-4xl">{{"Memberships" | translate}}</h1>
      <button mat-raised-button color="primary" class="text_color_white" matTooltip="{{'create new membership' | translate }}"
      (click)="newMembershipPopup()">
      <i class="fa-regular fa-circle-plus" style="font-size: 2vh; padding-right: 1vh;"></i>{{'New membership' | translate}}
      </button>
    </div>
    <br>

    <div class="w-full flex flex-col gap-3">
      <!-- Search Membership Form -->
      <div class="bg-white w-full rounded-xl shadow-sm border-solid border-[0.025rem] p-7">
        <form  [formGroup]="searchMembershipForm!" class="w-full">
          <div class="flex flex-col w-full gap-5">

            <div class="w-full flex flex-row justify-between">
              <p class="font-semibold text-[#475569]">{{"Search memberships" | translate}}</p>

              <div class="flex flex-row gap-5">
                <button
                class="transition-opacity duration-200 ease-in-out w-full h-full"
                [ngClass]="{'opacity-100 hover:cursor-pointer': searchDataActive, 'opacity-0 hover:cursor-auto pointer-events-none select-none': !searchDataActive}"
                (click)="cancelSearchData();" matTooltip='{{"Ресетирај филтри"}}'>
                  <div class="flex flex-row  justify-between gap-3 align-middle items-center">
                    <i class="lg:text-[1.35rem] text-[1.15rem] fa-solid fa-xmark text-[#f44336]"> </i>
                    <p class="lg:text-[1.35rem] text-[1.15rem] text-[#f44336]"> {{"Reset Filters" | translate }} </p>
                  </div>
                </button>

                <button mat-mini-fab color="primary" (click)="searchMembership();" matTooltip='{{"Search" | translate}}'>
                  <i class="fa-solid fa-magnifying-glass" style="display: contents;"></i>
                </button>

              </div>
            </div>

            <div class="flex flex-col lg:flex-row w-full justify-between gap-3 lg:gap-[2rem]">

              <div class="flex flex-col gap-1 w-full">
                <mat-label>{{"Search by membership type" | translate}}</mat-label>
                <mat-form-field appearance="outline" class="flex flex-row items-center">

                  <mat-icon matPrefix><i class="fa-regular fa-address-card text-[2rem] pr-[1rem]"></i> </mat-icon>

                  <mat-select [formControlName]="'membershipType'"
                    placeholder='{{"Choose membership" | translate}}'
                    [ngModelOptions]="{standalone: true}">
                    <mat-option [value]="null"> {{"Show all" | translate}} </mat-option>
                    <mat-option *ngFor="let option of membershipTypes" [value]="option.id" [ngClass]="{'hidden': option.active !== true}"> {{ option.name }}</mat-option>
                  </mat-select>

                </mat-form-field>
              </div>

              <div class="flex flex-col gap-1 w-full">
                <mat-label>{{"Search by client" | translate}}</mat-label>
                <mat-form-field appearance="outline" class="flex flex-row items-center">

                  <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i> </mat-icon>

                  <mat-select [formControlName]="'client'"
                    placeholder='{{"Client" | translate}}'
                    [ngModelOptions]="{standalone: true}">
                    <mat-option [value]="null"> {{"Show all" | translate}} </mat-option>
                    <mat-option *ngFor="let client of clients" [value]="client.profileId"> {{client.name}} {{client.surname}}</mat-option>
                  </mat-select>

                </mat-form-field>
              </div>

            </div>

            <div class="flex items-center gap-2 mt-1 ml-[.35rem]">
              <div>
                <input class=" bg-slate-950" type="checkbox" id="checkbox" name="checkbox" [formControlName]="'checkbox'" (change)="handleCheckboxChange()">
              </div>
              <h1 class="text-[1.2rem] lg:text-[1.4rem] ml-1">{{"Show active memberships" | translate }}</h1>
            </div>

          </div>
        </form>
      </div>

      <!-- Memberships Table Desktop -->
      <div  *ngIf="windowDimensions.width >= windowDimensions.threshold_lg"
            class="bg-white w-full rounded-[0.75rem] border-solid border-[0.025rem] border-[#E0E0E0] mt-4 overflow-x-auto ">
      <table class=" w-full">
        <thead class="bg-[#F4F6F9] w-full">
          <tr>
            <!-- <th class="p-5" *ngFor="let columnName of columnNames">{{ columnName }}</th> -->
            <th class="p-5 font-semibold">{{ "Client" | translate }}</th>
            <th class="p-5 font-semibold">{{ "typeName" | translate }}</th>
            <th class="p-5 font-semibold">{{ "Validity" | translate }}</th>
            <th class="p-5 font-semibold">{{ "Status" | translate }}</th>
            <th class="p-5 font-semibold">{{ "Sessions" | translate }}</th>
            <th class="p-5 font-semibold w-20">{{"change" | translate }}</th>
          </tr>
        </thead>
        <tbody class="">
          <tr *ngFor="let item of filteredMembershipInfo; let last = last" class="border-b border-[#F8F8F8] pb-5" [ngClass]="{'hidden': isChecked && item.status?.status !== true}">
            <td class="px-7 pt-5 pb-5">{{ item.name}} {{item.surname}}</td>
            <td class="px-7 pt-5 pb-5">{{ item.membershipTypeName }}</td>

            <td  class="px-7 pt-5 pb-5">{{ item.fromDate | date:'dd.MM.yyyy'}} -
              <ng-container *ngIf="item.toDate; else displaySlash">{{ item.toDate | date:'dd.MM.yyyy' }}</ng-container>
              <ng-template #displaySlash>/</ng-template>

            </td>
            <td [ngClass]="{'pb-5': last}" class="px-7 pt-5">
              <div class="flex items-center gap-2">
              <div [ngClass]="{'bg-[#3FA155]': item.status?.status === true, 'bg-[#DA1414]': item.status?.status !== true}"
          class="rounded-full w-3 h-3">
              </div>
            <div>{{item.status?.message}}</div>
          </div>

            </td>
            <td [ngClass]="{'pb-5': last}" class="px-7 pt-5"> {{item.credits}} </td>
            <td [ngClass]="{'pb-5': last}" class="px-7 pt-5">
              <div class="flex justify-center items-center">
            <button class="" mat-icon-button type="button" (click)="openEditMembershipPopup(item)">
              <!--[routerLink]="[ dataGridSettings.editUrl, element['id'] ]"-->
              <i class="fa-solid fa-pencil"></i>
            </button>
          </div>
          </td>
          </tr>
        </tbody>
      </table>
      </div>

      <!-- Memberships Table Mobile -->
      <div *ngIf=" windowDimensions.width < windowDimensions.threshold_lg">
        <div *ngFor="let item of filteredMembershipInfo" [ngClass]="{'hidden': isChecked && item.status?.status !== true}"
          class="border-solid border-[0.025rem] bg-white border-[#E0E0E0] rounded-xl mt-10 py-5 px-8">

          <div class="relative flex flex-row">
            <div class="uppercase absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <span>{{item.name }}</span>
              <span class=""> {{ item.surname}}</span>
            </div>

            <div class="w-full flex flex-row justify-end align-middle items-end">
              <button mat-icon-button type="button" (click)="openEditMembershipPopup(item)">
                <i class="fa-solid fa-pencil"></i>
              </button>
            </div>
          </div>

          <hr class="border-solid border-[#E0E0E0] mb-4">
          <div class="flex flex-col">
            <div>{{item.membershipTypeName}}</div>
            <div>
              {{item.fromDate | date:'dd.MM.yyyy'}} -
              <ng-container *ngIf="item.toDate">{{ item.toDate | date:'dd.MM.yyyy' }}</ng-container>
              <ng-container *ngIf="!item.toDate">/</ng-container>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <div [ngClass]="{'bg-green-500': item.status?.status === true, 'bg-red-500': item.status?.status !== true}"
              class="rounded-full w-3 h-3">
            </div>
            <div>
              {{item.status?.message}}
            </div>
          </div>
          <div>{{"Remaining sessions" | translate }} {{item.credits}}</div>
        </div>
      </div>
    </div>

  </div>

  <!-- Membership Type List - Right -->
  <div sideNavContent class="w-full">
    <div class="flex-row items-center w-full">
      <div class="w-full">
        <div class="bg-white p-4 w-full mb-8 rounded-xl border-solid border-[0.02rem] shadow" *ngFor="let type of membershipTypes; let first = first; let i = index;" [ngClass]="{'hidden': type.active !== true}">
          <div class="flex justify-between w-full">
            <div class="font-bold w-[75%]">{{type.name}}</div>
            <div class="flex flex-row items-center justify-end align-middle w-[25%] gap-4 ml-2 h-max mt-[.35rem]">
            <div class="w-6 flex justify-center items-center">
              <img src="/assets/image/edit.svg" alt="edit" class="w-6 cursor-pointer" (click)="openNewCategoryPopup(type)">
            </div>
            <div class="w-6 cursor-pointer flex justify-center items-center" (click)="onOpenDeletePopup(type)">
              <i class="fa-regular fa-trash-can" ></i>
            </div>
            <div class="flex justify-center items-center cursor-pointer w-6"
                  (click)="toggleViewMore(i)">
            <img src="/assets/image/arrow-down.svg" alt="down" 
            class="w-6 transition-all duration-150 ease-in-out" [ngClass]="{'rotate-180': viewMore[i]}">
            </div>
            </div>
          </div>
        <div class="w-2/3 text-light-gray">{{type.description}}</div>

        <div>
          <div class="flex flex-col items-start mt-5 gap-4 transition-all duration-150 ease-in-out" 
          [ngClass]="{'max-h-[1000px] opacity-100 visible mb-3': viewMore[i], 'max-h-[0px] mb-0 opacity-0 invisible': !viewMore[i]}">
            <hr class="border-solid w-full border-[#515151]">
            <div class="flex items-center gap-3">
              <img src="/assets/image/workout.svg" class="w-9">
              <div class="text-[#373737]">
                {{"Sessions number" | translate}}: <span class="font-bold">{{type.credits}}</span>
              </div>
            </div>
            <div class="flex items-center gap-3 ">
              <img src="/assets/image/price.svg" class="w-9">
              <div class="text-[#373737]">
                {{"Price" | translate}}: <span class="font-bold">{{type.price}} {{ "den" | translate }}.</span>
              </div>
            </div>
          </div>
        </div>

        </div>
        <div class="flex justify-center">
          <div class="flex flex-col justify-center align-middle">
            <button class="bg-secondary px-10 py-4 rounded-xl flex justify-center mb-4 mt-12" (click)="openNewCategoryPopup()">
              <div class="flex gap-4">
                <img src="/assets/image/add.svg" class="h-9">
                <div class="uppercase text-white">
                  {{"New category" | translate}}
                </div>
              </div>
            </button>
          </div>
      </div>
      </div>
    </div>
  </div>

</app-generic-side-modal-container>

<!-- New Membership Popup  -->
<app-generic-modal #newMembershipPopup *ngIf="showNewMembershipPopup"
    [modal_state_function]="onCloseMembershipPopup"
    [bannerText]=" 'new-user-membership' | translate "
    [handle_extreme_overflow]="false"
    [handle_mobile]="true"
    (handleCloseEmitter)="onCloseMembershipPopup()">
    <div class="py-2 sm:py-0 px-5 sm:px-0 w-[100%] sm:w-[45rem]">
      <div class="flex flex-col w-full" >
        <form [formGroup]="newMembershipForm!" (submit)="onAddNewMembership()">

        <mat-label>{{"Client" | translate }}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never" class="w-full">
          <mat-icon matPrefix>
            <i class="fa-regular fa-user"></i>
          </mat-icon>
          <mat-select [formControlName]="'client'"
            required>
            <mat-option value="" disabled selected>{{"Client" | translate }}</mat-option>
            <mat-option *ngFor="let client of clients" [hidden]="true" [value]="client.profileId">
              {{ client.name }} {{client.surname}}
            </mat-option>

          </mat-select>
          <mat-error *ngIf="newMembershipForm.get('client')! && newMembershipForm.get('client')?.errors">
            <span *ngIf="newMembershipForm.get('client')?.hasError('required')">{{"Required Field" |translate}}</span>
          </mat-error>
        </mat-form-field>

          <mat-label>{{"Membership type" | translate }}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never" class="w-full">
          <mat-icon matPrefix>
            <i class="fa-regular fa-address-card"></i>
          </mat-icon>
          <mat-select [formControlName]="'membership_type'"
            required>
            <mat-option value="" disabled selected>{{"Select a membership type" | translate }}</mat-option>
            <mat-option *ngFor="let membershipType of membershipTypes" [hidden]="true" [value]="membershipType.id" [ngClass]="{'hidden': membershipType.active !== true}">
              {{ membershipType.name }}
            </mat-option>

          </mat-select>
          <mat-error *ngIf="newMembershipForm.get('client')! && newMembershipForm.get('client')?.errors">
            <span *ngIf="newMembershipForm.get('client')?.hasError('required')">{{"Required Field" |translate}}</span>
          </mat-error>
        </mat-form-field>

          <mat-label>{{"Validate from" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="flex flex-row items-center w-full">
                <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i> </mat-icon>
                <input matInput [matDatepicker]="pickerFrom" [formControlName]="'valid_from'"
                    placeholder='{{"DD/MM/YYYY" | translate}}'
                    (dateChange)="onDateChangeNewMembership($event)"
                    required>
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error *ngIf="newMembershipForm.get('valid_from')! && newMembershipForm.get('valid_from')?.errors">
                  <span *ngIf="newMembershipForm.get('valid_from')?.hasError('required')">{{"Required Field" |translate}}</span>
                </mat-error>
            </mat-form-field>

            <mat-label>{{"Validate to" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="flex flex-row items-center w-full">
                <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i> </mat-icon>
                <input matInput [matDatepicker]="pickerTo" [formControlName]="'valid_to'" [min]="selectedFromDateNewMembership"
                    placeholder='{{"DD/MM/YYYY" | translate}}'>
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
            </mat-form-field>

          <div class="text-[#D94E4E] bg-warning_bg p-5 rounded-md mt-3 flex gap-4" *ngIf="showUserAlreadyExists">
            <img src="/assets/image/warning.svg">
            <div>{{"already membership active" | translate }}</div>
          </div>

          <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-[2rem]">
            <button (click)="onCloseMembershipPopup(); $event.preventDefault()"
                    class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
              {{'back' | translate}}
            </button>
            <button  type="submit"
            [disabled]="newMembershipForm.invalid" [ngClass]="{
              'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': newMembershipForm.valid,
              'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': newMembershipForm.invalid
            }"
                     class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
                    {{'add' | translate}}
            </button>
          </div>
        </form>
      </div>
    </div>
</app-generic-modal>

<!-- Edit Membership Popup -->
<app-generic-modal #editMembershipPopup *ngIf="showEditMembershipPopup"
        [modal_state_function]="onCloseEditMembershipPopup"
        [bannerText]="'Уреди корисничка членарина'"
        [handle_extreme_overflow]="false"
        [handle_mobile]="true"
        (handleCloseEmitter)="onCloseEditMembershipPopup()">
    <div class="py-2 sm:py-0 px-5 sm:px-0 w-[100%] sm:w-[45rem]">
      <div class="flex flex-col w-full" >
        <form [formGroup]="editMembershipForm!" (submit)="onEditMembership()">

          <mat-label>{{"Client" | translate }}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never" class="w-full">
          <mat-icon matPrefix>
            <i class="fa-regular fa-user"></i>
          </mat-icon>
          <mat-select [formControlName]="'client'"
            required>
            <mat-option value="" disabled selected>{{"Client" | translate }}</mat-option>
            <mat-option *ngFor="let client of clients" [hidden]="true" [value]="client.profileId">
              {{ client.name }} {{client.surname}}
            </mat-option>

          </mat-select>
          <mat-error *ngIf="newMembershipForm.get('client')! && newMembershipForm.get('client')?.errors">
            <span *ngIf="newMembershipForm.get('client')?.hasError('required')">{{"Required Field" |translate}}</span>
          </mat-error>
        </mat-form-field>

          <mat-label>{{"new-membership-type" | translate }}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never" class="w-full">
          <mat-icon matPrefix>
            <i class="fa-regular fa-address-card"></i>
          </mat-icon>
          <mat-select [formControlName]="'membership_type'"
            required>
            <mat-option value="" disabled selected>{{"Select a membership type" | translate }}</mat-option>
            <mat-option *ngFor="let membershipType of membershipTypes" [hidden]="true" [value]="membershipType.id" [ngClass]="{'hidden': membershipType.active !== true}">
              {{ membershipType.name }}
            </mat-option>

          </mat-select>
          <mat-error *ngIf="newMembershipForm.get('client')! && newMembershipForm.get('client')?.errors">
            <span *ngIf="newMembershipForm.get('client')?.hasError('required')">{{"Required Field" |translate}}</span>
          </mat-error>
        </mat-form-field>

          <mat-label>{{"Validate from" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="flex flex-row items-center w-full">
                <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i> </mat-icon>
                <input matInput [matDatepicker]="fromPicker"
                      [formControlName]="'valid_from'"
                      placeholder='{{"DD/MM/YYYY" | translate}}'
                      (dateChange)="onDateChange($event)"
                      required>
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
                <mat-error *ngIf="newMembershipForm.get('valid_from')! && newMembershipForm.get('valid_from')?.errors">
                  <span *ngIf="newMembershipForm.get('valid_from')?.hasError('required')">{{"Required Field" |translate}}</span>
                </mat-error>
            </mat-form-field>

            <mat-label>{{"Validate to" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="flex flex-row items-center w-full">
                <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i> </mat-icon>
                <input matInput [matDatepicker]="toPicker" [formControlName]="'valid_to'" [min]="selectedFromDate"
                    placeholder='{{"DD/MM/YYYY" | translate}}'>
                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>

            <mat-label>{{"Remaining sessions" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <mat-icon matPrefix><i class="fa-regular fa-repeat"></i></mat-icon>
              <input type="number" matInput  maxlength="2"
              [formControlName]="'session_number'"
              [min]="0" required />
              <mat-error *ngIf="newMembershipForm.get('session_number')! && newMembershipForm.get('session_number')?.errors">
                <span *ngIf="newMembershipForm.get('session_number')?.hasError('required')">{{"Required Field" |translate}}</span>
              </mat-error>
          </mat-form-field>

          <div class="text-[#D94E4E] bg-warning_bg p-5 rounded-md mt-3 flex gap-4" *ngIf="showUserAlreadyExists">
            <img src="/assets/image/warning.svg">
            <div>{{"already membership active" | translate }}</div>
          </div>

          <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-[2rem]">
            <button (click)="onCloseEditMembershipPopup(); $event.preventDefault()"
            class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
              {{'back' | translate}}
            </button>
            <button  type="submit"
            [disabled]="editMembershipForm.invalid" [ngClass]="{
              'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': editMembershipForm.valid,
              'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': editMembershipForm.invalid
            }"
                     class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
                    {{'add' | translate}}
            </button>
          </div>
        </form>
      </div>
    </div>
</app-generic-modal>

<!-- Add Membership Type Popup -->
<app-generic-modal #addMembershipTypePopup *ngIf="showPopup"
                    [modal_state_function]="onCloseAddMembershiptTypePopup"
                    [bannerText]="selectedType == undefined ? ('new-membership-type' | translate ) : ('Edit membership type' | translate )"
                    [handle_extreme_overflow]="false"
                    [handle_mobile]="true"
                    (handleCloseEmitter)="onCloseAddMembershiptTypePopup()">
  <div class=" py-2 sm:py-0 px-5 sm:px-0 w-[100%] sm:w-[45rem]">
    <div class="flex flex-col w-full" >
      <form [formGroup]="newCategoryForm!" (submit)="addNewMembershipType()">

        <mat-label>{{"membership name" | translate }}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never" class="w-full">
          <mat-icon matPrefix><i class="fa-regular fa-address-card pt-2"></i></mat-icon>
          <input matInput  type="text" [formControlName]="'membership_name'"
            minlength="3" placeholder="{{'Име на членарина' | translate}}">
          <mat-error *ngIf="newCategoryForm.get('membership_name')! && newCategoryForm.get('membership_name')?.errors">
            <span *ngIf="newCategoryForm.get('membership_name')?.hasError('required')!">{{"Required Field" | translate}}</span>
          </mat-error>
        </mat-form-field>

        <mat-label>{{"Sessions number" | translate}}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <mat-icon matPrefix><i class="fa-regular fa-stopwatch-20"></i></mat-icon>
              <input type="number" matInput  maxlength="2"
              [formControlName]="'session_number'"
              [placeholder]="'Број на сесии'"
              [min]="0" required />
              <mat-error *ngIf="newCategoryForm.get('session_number')! && newCategoryForm.get('session_number')?.errors">
                <span *ngIf="newCategoryForm.get('session_number')?.hasError('required')">{{"Required Field" |translate}}</span>
              </mat-error>
          </mat-form-field>

          <mat-label>{{"price" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-icon matPrefix><i class="fa-solid fa-coins"></i></mat-icon>
            <input matInput type="number"
                   min="0"
                   class="text-xs sm:text-sm"
                   [formControlName]="'price'"
                   placeholder='{{"Price" | translate }}' required>

            <span matSuffix style="vertical-align: super;">{{"denar" | translate }}</span>
            <mat-error *ngIf="newCategoryForm.get('price')! && newCategoryForm.get('price')?.errors">
              <span *ngIf="newCategoryForm.get('price')?.hasError('required')">{{"Required Field" |translate}}</span>
            </mat-error>
          </mat-form-field>

        <mat-label>{{"desc-opt" | translate }}</mat-label>
              <mat-form-field appearance="outline" style="width: 100%;">
                <div style="display: flex; align-items: flex-start;">
                  <mat-icon matPrefix style="margin-top: 4px; margin-right: 8px;"><i class="far fa-file"></i></mat-icon>
                  <textarea matInput type="text" rows="5"  minlength="3"
                  placeholder="{{'A brief description of the membership' | translate}}"
                  [formControlName]="'description'"></textarea>
                </div>
              </mat-form-field>

      <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-[2rem]">
          <button (click)="onCloseAddMembershiptTypePopup(); $event.preventDefault()"
                  class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
            {{'back' | translate}}
          </button>
          <button  type="submit"
          [disabled]="newCategoryForm.invalid" [ngClass]="{
            'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': newCategoryForm.valid,
            'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': newCategoryForm.invalid
          }"
          class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
          {{'add' | translate}}
          </button>
      </div>

    </form>
  </div>
</div>
</app-generic-modal>

<!-- Delete Membership Type Popup -->
<app-generic-modal #deleteMembershipPopup *ngIf="showDeletePopup"
                    [modal_state_function]="onCloseDeletePopup"
                    [bannerText]="'delt-membership-type' | translate"
                    [handle_extreme_overflow]="false"
                    [handle_mobile]="true"
                    (handleCloseEmitter)="onCloseDeletePopup()">

              <div class="box width_100_percent">
                <div>
                  <div class="flex flex-col gap-5">
                    <div class="flex flex-col center gap-1">
                      <lord-icon  src="https://cdn.lordicon.com/drxwpfop.json" trigger="hover"
                        colors="primary:#b4b4b4,secondary:#b98d78" style="width:150px;height:150px">
                      </lord-icon>
                    </div>

                    <div class="flex flex-col center gap-1 padding_20 text-center">
                      <mat-label >{{"sure delete type question" | translate }}</mat-label>
                    </div>


                  </div>
                </div>

                <div class="bg-white p-4 w-full mb-8 rounded-xl border-solid border-[0.02rem] shadow">
                  <div class="flex justify-between">
                    <div class=" font-bold">{{selectedTypeDelete?.name}}</div>
                    </div>
                <div class="w-2/3 text-light-gray">{{selectedTypeDelete?.description}}</div>
                </div>

                <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-[2rem]">
                  <button (click)="onCloseDeletePopup(); $event.preventDefault()"
                          class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] active:scale-[0.985] active:shadow-sm">
                    {{'back' | translate}}
                  </button>
                  <button  (click)="onDeleteMembershipType(); $event.preventDefault()"
                  class="w-1/2 bg-[#b98d78] hover:bg-[#a57d6a] px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
                  {{"Confirm" | translate}}
                  </button>
              </div>
              </div>
</app-generic-modal>

